import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import FileSystem from 'components/file_system';
import { rootFolder } from './config';

export default function Breadcrumbs({ currentFolder, folders, onFolderClick }) {
  const breadcrumbs = useMemo(() => {
    const breadcrumbs = [];

    let currentId = currentFolder?.id;
    while (currentId) {
      const folder = folders.find(folder => folder.id == currentId);
      breadcrumbs.unshift({ id: currentId, name: folder.name });
      currentId = folder.parentFolderId;
    }

    return [rootFolder, ...breadcrumbs];
  }, [currentFolder, folders]);

  return (
    <div aria-label="breadcrumbs" className="flex-fill">
      <FileSystem.Breadcrumbs
        folders={breadcrumbs}
        onNavigation={onFolderClick}
      />
    </div>
  );
}

Breadcrumbs.propTypes = {
  currentFolder: PropTypes.shape({
    id: PropTypes.number,
  }),
  folders: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    parentFolderId: PropTypes.number,
  })).isRequired,
  onFolderClick: PropTypes.func.isRequired,
};
